(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-header"><a href="{{ \'HOME_PAGE\' | translate }}" nga11y-focus><img alt="Hydro-Quebec" src="/images2016/logo-hydro-quebec-couleur.svg"></a> <a ui-sref="start">{{ \'QUIT\' | translate }}</a></div>',
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingHeader', component);
}());
